module.exports = __webpack_public_path__ + "static/img/iconmore.89cdac37.svg";